var Activity = require("components/writing/activities/Activity");
var Glyphicon = require("components/utility/icons/Glyphicon");
var CurrentUser = require("lib/account/CurrentUser");
var TeacherPreviewNotice = require("components/utility/TeacherPreviewNotice");
var Modal = require("components/utility/AltModal");
var Spinner = require("components/utility/Spinner");
var EvaluationTags = require("components/writing/evaluations/EvaluationTags");
var EvaluationBox = require("components/writing/evaluations/EvaluationBox");
var CommentBox = require("components/social/comments/CommentBox");
var ShareResponse = require("components/writing/responses/ShareResponse");
var StudentActivityInfoLine = require("components/writing/responses/StudentActivityInfoLine");
var Features = require('lib/account/Features');

require("writing/responses/response_modal.scss");

class ResponseModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			response: null, newsFeedItem: null, loaded: false
		};
	}

	show() {
		if (!this.state.loaded) {
			this.setState({ loaded: true }, function() {
				this.loadResponseData();
				this.refs.modal.show();
			}.bind(this))
		} else {
			this.refs.modal.show();			
		}
	}

	editResponse() {
		var path = "/responses/new?activity_id=" + this.state.response.activity.id + "&edit_response_id=" + this.state.response.id;
		window.open(path, "_blank");
	}

	render() {
		if (this.state.response == null) {
			var responseContent = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		} else {
			if (this.props.adminPreview) {
				var previewNotice = (
					<TeacherPreviewNotice />
				);
			}
			var infoLine = (
				<StudentActivityInfoLine response={ this.state.response } user={ this.props.user } />
			)

			if (CurrentUser.hasID(this.state.response.user_id) || CurrentUser.isAdmin()) {
				var evaluation = (
					<EvaluationBox response={ this.state.response } />
				);
				var tags = (
					<div><EvaluationTags response={ this.state.response } editable={ false } /></div>
				);
			}

			// for now, remove options for sharing collages
			if (CurrentUser.isAdmin() && (this.state.response.activity.format.format_class != "CollageFormat")) {
				var socialShare = <ShareResponse responseID={ this.state.response.id } />
			}

			if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
				var commentBox = (
					<CommentBox subjectID={ this.state.response.id } subjectType="JournalActivityExercise"
						blockFirstComment={ CurrentUser.isStudent() }
						userID={ this.state.response.user_id } initialCollapsed={ !CurrentUser.isStudent() } />
				)
			}

			// if (CurrentUser.hasID(this.state.response.user_id) && !this.props.adminPreview) {
			// 	var editAction = (
			// 		<a className="editResponse" onClick={this.editResponse}>Edit Response <Glyphicon icon="pencil"/> </a>
			// 	)
			// }



			var responseContent = (
				<div className="responseWrap">
					{ previewNotice }
					{ infoLine }
					{ evaluation }
					{ tags }
					<Activity activity={ this.state.response.activity } response={ this.state.response } />
					{ commentBox }
				</div>
			);
		}

		return (
			<Modal className="responseModal veryWideModal" ref="modal" onHide={ this.props.onHide } >
				{ responseContent }
				{ socialShare }
			</Modal>
		)
	}

	loadResponseData() {
		var responseParams = { embed: "response.activity,activity.format,response.input_data,response.activity_data,response.evaluation,response.mirror_user_ids,response.text" };
		CurrentUser.api().getResponse(this.props.responseID, responseParams, $wr.apiHandler(function(response) {
			this.setState({ response: response.response });
		}.bind(this)));

		// var newsFeedItemParams = { embed: "news_feed_item.comments,comment.user,student.avatar" };
		// CurrentUser.api().getResponseNewsFeedItem(this.props.responseID, newsFeedItemParams, $wr.apiHandler(function(response) {
		// 	this.setState({ newsFeedItem: response.news_feed_item });
		// }.bind(this)));
	}

	componentDidMount() {
	}
};

ResponseModal.propTypes = StrictPropTypes({
	// ID of the response we're loading
	responseID: PropTypes.number.isRequired,

	// Function to call after the modal is hidden
	onHide: PropTypes.func,

	// The user of the response (optional, will only show the student if provided)
	user: PropTypes.object,

	// This is an admin viewing an preview of the completed activity
	adminPreview: PropTypes.bool
});

module.exports = ResponseModal;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/ResponseModal.js